import { render, staticRenderFns } from "./study-participant-documents.vue?vue&type=template&id=5e1b0d3b&"
import script from "./study-participant-documents.vue?vue&type=script&lang=js&"
export * from "./study-participant-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "study-participant-documents.vue"
export default component.exports